import React from 'react';
import classNames from 'classnames';
import styles from './Grabber.module.css';

interface GrabberProps {
  className?: string;
}

export const Grabber: React.FC<GrabberProps> = ({ className }) => {
  return (
    <div className={classNames(styles.grabber, className)}>
      <div className={styles.handle} />
    </div>
  );
};
